import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { CentredWrapper, Icon, ScreenIntroText } from '@/components';
export const ContactSite = () => {
    const { t } = useTranslation();
    return (_jsxs(CentredWrapper, Object.assign({ textAlign: 'center' }, { children: [_jsx(Icon, { color: 'red', name: 'exclamation-circle', size: '60px', strokeWidth: '1' }), _jsx(ScreenIntroText, { subtitle: t('app:components.contact_site.subtitle'), title: t('app:components.contact_site.title') })] })));
};
